import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comDocPerson/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comDocPerson/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comDocPerson/insert.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' },
        method: 'post',
        data:   query, 
    }); 
    return list;
};
//获取文件详情
export const getFilesDetail = query => {  
    var list = request({
        url: 'comDocPerson/getFormartFiles.do', 
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

//获取文件详情
export const getListData = query => {  
    var list = request({
        url: 'comDocPerson/getDocFileList.do', 
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const handDelete = query => {  
    var list = request({
        url: 'comDocPerson/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const deleteMore = query => {  
    var list = request({
        url: 'comDocPerson/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comDocPerson/update.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' },
        method: 'post',
        data:   query, 
    }); 
    return list;
};


export const fetchSelect = query => {  
    var list = request({
        url: 'comDocPerson/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
export const downDocFile = query => {  
    var list = request({
        url: 'comDocPerson/getFileDown.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};